<template>
  <div class="orderList">
    <navBar title="总订单" :is-list="true"></navBar>
    <van-tabs color="#333" v-model="activeIndex" @change="orderTab">
      <van-tab :title="sItem.name" v-for="(sItem,sIndex) in statusList" :key="sIndex">
      </van-tab>
    </van-tabs>

    <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh" v-if="orderList.length>0">
      <van-list v-model="isUpLoading" :finished="upFinished" :immediate-check="false" :finished-text="text"
                @load="onLoadList" :offset="offset">
        <div class="orderItem"
             v-for="(oItem,oIndex) in orderList"
             :key="oIndex"
             @click="toContent(oItem.order_status,oItem.id)"
        >
          <div class="top flexBetween">
            <div class="left">
              <span class="cancel" v-if="oItem.order_status==16">订单-待确认</span>
              <span class="primary" v-if="oItem.order_status==26">订单-配货中</span>
              <span class="primary" v-if="oItem.order_status==27">订单-待取货</span>
              <span class="normal" v-if="oItem.order_status==40">订单-已完成</span>
              <span class="time">{{oItem.create_time}}</span>
            </div>
            <div class="right"></div>
          </div>
          <div class="bottom" v-if="oItem.order_address">
            <div class="address">{{oItem.order_address.address}}</div>
            <div class="info flexBetween">
              <div class="left">
                <span class="name">{{oItem.order_address.contacts}}</span>
                <span class="tel">{{oItem.order_address.mobile}}</span>
              </div>
              <div class="right">共{{oItem.num}}件</div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Tab, Tabs, List, PullRefresh} from 'vant';

  Vue.use(Tab).use(Tabs).use(List).use(PullRefresh);

  import navBar from "../../../components/navBar";

  export default {
    name: "orderList",
    components: {
      navBar
    },
    data() {
      return {
        statusList: [
          {
            name: '待确认',
            status: 16
          }, {
            name: '配货中',
            status: 26
          }, {
            name: '待取货',
            status: 27
          }, {
            name: '已完成',
            status: 40
          }
        ],
        activeIndex: 0,//当前选中项
        orderList: [],//订单列表
        pageIndex: 1,//当前页数
        status: 16,//列表当前选中状态
        isDownLoading: false,  // 下拉刷新
        isUpLoading: false,    // 上拉加载数据
        upFinished: false,     // 上拉加载完成已没有更多数据
        offset: 100,           // 距离底部距离触发上拉加载数据函数
        text: '' // 当搜索条数不足一页时文字提示
      }
    },
    mounted() {
      this.getOrderList();
    },
    methods: {
      // 上拉加载
      onLoadList() {
        this.page++;
        this.getOrderList();
      },
      // 下拉刷新
      onDownRefresh() {
        this.page = 1;
        this.upFinished = false;
        this.getOrderList();
      },
      //订单状态切换
      orderTab(name) {
        this.status = this.statusList[name].status;
        // 清空数组和页码
        this.page = 1;
        this.orderList = [];
        // 如果某一次加载完成了，再点击跳转就不会触发上拉加载了
        this.upFinished = false;

        // 调用获取订单数据
        this.getOrderList();
      },
      //获取订单列表
      getOrderList() {
        this.sendHttp({
          method: 'post',
          url: `${this.orderUrl}/communityorder/parentorderpage`,
          data: {
            order_status: this.status,
            page: this.pageIndex
          }
        }).then(res => {
          console.log(res.data);
          if (res.code == '0') {
            // 判断是否有数据
            if (res.data == null || res.count === 0) {
              this.upFinished = true;
              return;
            }
            // 当数据不足一页或加载完成时文字提示
            if (this.orderList.length >= res.count) {
              this.upFinished = true;
              this.text = '没有更多了';
            }

            if (res.count < 5) {
              this.text = '';
            }

            // this.$nextTick()将回调延迟到下次 DOM 更新循环之后执行。
            this.$nextTick(() => {
              this.isUpLoading = false;
            })

            // 数据处理
            if (this.page === 1) {
              // 防止下拉刷新时触发上拉加载
              if (this.isDownLoading) {
                this.isDownLoading = false;

                if (this.upFinished) {
                  this.upFinished = false;
                }
              }
              this.orderList = res.data;
            } else {
              this.orderList = this.orderList.concat(res.data);
            }
            console.log(res)

          }
        })
      },
      //跳转订单详情
      toContent(status, id) {
        this.$router.push({
          path: "/allOrderContent",
          query: {
            status: status,
            id: id
          }
        })
      },
    }
  }
</script>

<style scoped lang="less">
  .orderList {
    position: absolute;
    width: 100%;
    min-height: 100%;
    top: 0;
    left: 0;
    background: #f5f5f5;

    .orderItem {
      margin-top: 6px;
      background: #fff;
      padding: 0 14px;

      .top {
        line-height: 44px;
        font-size: 14px;
        border-bottom: 1px solid #f5f5f5;

        .left {
          span {
            font-weight: bold;
          }

          .time {
            font-weight: normal;
          }

          .primary {
            color: #687BFF;
          }

          .danger {
            color: #DE1919;
          }

          .cancel {
            color: #8D95A6;
          }

          .time {
            margin-left: 12px;
            font-size: 12px;
            color: #8D95A6;
          }
        }

        .right {
          width: 7.2px;
          height: 12px;
          background: url("../../../assets/images/rtArrow.png") no-repeat;
          background-size: contain;
        }

      }

      .bottom {
        padding: 14px;

        .address {
          font-size: 14px;
          padding-bottom: 8px;
        }

        .info {
          font-size: 14px;

          .left {
            font-size: 13px;

            .name {
              color: #687BFF;
              margin-right: 10px;
            }

            .tel {
              color: #8D95A6;
            }
          }

        }
      }
    }
  }
</style>


